/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import classNames from 'classnames';
import { Placeholder, PlaceholderText } from 'sarsaparilla';
import './CampgroundPageV3ReviewsPlaceholder.scss';

type CampgroundPageV3ReviewsPlaceholderProps = {
    /** When true, parent section already applies vertical spacing (e.g. live Reviews block). */
    embedded?: boolean;
};

export default function CampgroundPageV3ReviewsPlaceholder({
    embedded = false,
}: CampgroundPageV3ReviewsPlaceholderProps) {
    return (
        <div
            className={classNames('campground-page-v3-reviews-placeholder', {
                'campground-page-v3-reviews-placeholder--embedded': embedded,
            })}
            aria-hidden="true"
        >
            <div className="campground-page-v3-reviews-placeholder-header">
                <Placeholder
                    className="campground-page-v3-reviews-placeholder-title"
                    height="32px"
                    width="180px"
                />
                <Placeholder
                    className="campground-page-v3-reviews-placeholder-rating"
                    height="24px"
                    width="124px"
                />
            </div>

            <div className="campground-page-v3-reviews-placeholder-tabs">
                <div className="campground-page-v3-reviews-placeholder-tab-item">
                    <Placeholder height="32px" width="100%" />
                </div>
                <div className="campground-page-v3-reviews-placeholder-tab-item">
                    <Placeholder height="32px" width="100%" />
                </div>
                <div className="campground-page-v3-reviews-placeholder-tab-item">
                    <Placeholder height="32px" width="100%" />
                </div>
                <div className="campground-page-v3-reviews-placeholder-tab-item">
                    <Placeholder height="32px" width="100%" />
                </div>
                <div className="campground-page-v3-reviews-placeholder-tab-item">
                    <Placeholder height="32px" width="100%" />
                </div>
            </div>

            <div className="campground-page-v3-reviews-placeholder-card">
                <Placeholder height="20px" width="116px" />
                <PlaceholderText fontSize={19} lineHeight={22} lines={5} />
            </div>

            <Placeholder height="44px" width="100%" />
        </div>
    );
}
